import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Confirm, Grid, Loader } from 'semantic-ui-react';
import moment from 'moment';
import { financialCategoryActions } from '../../actions/financial-category.actions';

class FinancialCategoryShowScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      name: '',
      submitted: false,
    };
  }

  handleCancel = () => this.setState({ open: false });

  deleteShow = () => this.setState({ open: true });

  componentDidMount() {
    const { match, dispatch } = this.props;

    dispatch(financialCategoryActions.getById(match.params.id));
  }

  deleteById() {
    const { match, dispatch } = this.props;

    dispatch(financialCategoryActions.deleteById(match.params.id)).then(() =>
      this.props.history.push('/finance/categories'),
    );
  }

  editById() {
    const { match } = this.props;

    this.props.history.push(`/finance/categories/${match.params.id}/edit`);
  }

  render() {
    const { subCategory, loading } = this.props;
    const { open } = this.state;
    if (!subCategory) {
      return <Loader active={loading} />;
    }

    return (
      <Fragment>
        <Confirm
          content="Deseja remover esse item?"
          open={open}
          onCancel={this.handleCancel}
          onConfirm={() => this.deleteById()}
        />
        <Loader active={loading} />
        <Grid className="header-page">
          <Grid.Column mobile={16} tablet={10} computer={10}>
            <h1>{subCategory.name}</h1>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={6} computer={6} textAlign="right">
            <Button icon="edit outline" title="Editar" onClick={() => this.editById()} />
            <Button icon="trash alternate outline" title="Remover" onClick={this.deleteShow} />
          </Grid.Column>
        </Grid>
        <div className="container-inner">
          <h4>Descrição </h4>
          {subCategory.description}
          <h4>Grupo: </h4>
          {subCategory?.category?.name}
          <h4>Criado em: </h4>
          {moment(subCategory.created_at).format('DD/MM/YYYY')}
          <h4>Atualizado em: </h4>
          {moment(subCategory.updated_at).format('DD/MM/YYYY')}
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { financialCategory } = state;
  return {
    subCategory: financialCategory.item,
    loading: financialCategory.loading || false,
  };
}

const connectedFinancialCategoryShowScreen = connect(mapStateToProps)(FinancialCategoryShowScreen);
export { connectedFinancialCategoryShowScreen as FinancialCategoryShowScreen };
